import { RestaurantMenuCategoryDTO } from '../../../../types/restaurant/RestaurantMenuTypes';

import MenuCategoryCard from './MenuCategoryCard';

interface MenuCategoryGridProps {
  categories: RestaurantMenuCategoryDTO[];
  onEdit: (category: RestaurantMenuCategoryDTO) => void;
  onToggle: (category: RestaurantMenuCategoryDTO) => void;
}

const MenuCategoryGrid = ({
  categories,
  onEdit,
  onToggle,
}: MenuCategoryGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:hidden">
      {categories.map((category) => (
        <MenuCategoryCard
          key={category.id}
          category={category}
          onEdit={onEdit}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

export default MenuCategoryGrid;
